import Contacts from "./contacts.js";
export default Contacts;